<template>
    <b-container fluid v-if="advert" class="align-self-center">
        <b-row>
            <b-col cols="12">
                <h2 class="text-center my-4">Edit advert</h2>
            </b-col>
            <b-col md="12" class="flex-center">
                <b-form v-on:submit.prevent="updateAdvert" class="w-75">
                    <b-form-group
                            horizontal
                            :label-cols="4"
                            breakpoint="md"
                            label="Klijent:"
                            label-for="client_id">
                        <select id="client_id"
                                class="form-control form-control-sm"
                                name="client_id"
                                :value="advert.client_id"
                                required>
                            <option selected disabled>Choose client</option>
                            <option v-for="client in clients" :value="client.id">
                                {{ client.name }}
                            </option>
                        </select>
                    </b-form-group>
                    <b-form-group
                            horizontal
                            :label-cols="4"
                            breakpoint="md"
                            label="Name:"
                            label-for="name">
                        <b-form-input id="name"
                                      type="text"
                                      size="sm"
                                      name="name"
                                      :value="advert.name"
                                      required>
                        </b-form-input>
                    </b-form-group>
                    <b-form-group
                            horizontal
                            :label-cols="4"
                            breakpoint="md"
                            label="Date from:"
                            label-for="date_from">
                        <b-form-input id="date_from"
                                      type="date"
                                      size="sm"
                                      name="date_from"
                                      :value="advert.date_from | moment('YYYY-MM-DD')"
                                      required>
                        </b-form-input>
                    </b-form-group>
                    <b-form-group
                            horizontal
                            :label-cols="4"
                            breakpoint="md"
                            label="Date to:"
                            label-for="date_to">
                        <b-form-input id="date_to"
                                      type="date"
                                      size="sm"
                                      name="date_to"
                                      :value="advert.date_to | moment('YYYY-MM-DD')"
                                      required>
                        </b-form-input>
                    </b-form-group>
                    <b-form-group
                            horizontal
                            :label-cols="4"
                            breakpoint="md"
                            label="Type:"
                            label-for="type">
                        <b-form-select id="type"
                                       :value="1"
                                       :options="types"
                                       size="sm"
                                       name="advert_type_id"
                                       v-model="advert.advert_type_id"
                                       required>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group
                            horizontal
                            :label-cols="4"
                            breakpoint="md"
                            label="Paid:"
                            label-for="paid">
                        <b-form-checkbox id="paid"
                                         size="sm"
                                         value="1"
                                         v-model="advert.paid"
                                         unchecked-value="0">
                        </b-form-checkbox>
                    </b-form-group>
                    <input type="hidden" name="paid" :value="advert.paid">
                    <b-form-group
                            horizontal
                            :label-cols="4"
                            breakpoint="md"
                            label="Interval:"
                            label-for="interval">
                        <b-form-checkbox-group id="interval"
                                               class="pl-0"
                                               size="sm"
                                               v-model="interval"
                                               :options="intervalOptions" />
                    </b-form-group>
                    <b-form-group
                            horizontal
                            :label-cols="4"
                            breakpoint="md"
                            label="File:"
                            label-for="advert_upload">
                        <b-form-file id="advert_upload"
                                     size="sm"
                                     name="advert_upload"
                                     :accept="advert.advert_type_id === '2' ? accepts[1] : accepts[0]"
                                     v-model="file">
                        </b-form-file>
                    </b-form-group>
                    <b-btn type="submit" variant="primary" class="w-100">Submit</b-btn>
                </b-form>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        data() {
            return {
                advert: null,
                clients: [],
                types: [
                    {text: 'Basic', value: '1'},
                    {text: 'Driver', value: '2'},
                    {text: 'Highline', value: '3'},
                    {text: 'Videostar', value: '4'}
                ],
                intervalOptions: [
                    { text: 'Day', value: 1 },
                    { text: 'Night', value: 2 }
                ],
                accepts: [
                    "image/jpeg, image/png, image/gif",
                    "video/mp4,video/x-m4v,video/*"
                ],
                file: null,
                interval: []
            }
        },
        methods: {
            updateAdvert: function (e) {
                const formData = new FormData(e.target);
                let sum = 0;
                this.interval.forEach( item => sum += item);
                formData.append('interval', sum);
                adamApi.post(api.adverts + this.$route.params.id, formData).
                then( response => {
                        if (response.status === 200) {
                            this.$router.push('/adverts/' + response.data.id);
                        }
                    }
                )
            }
        },
        created () {
            adamApi.get(api.adverts + this.$route.params.id).
            then(response => {
                if (response.status === 200) {
                    this.advert = response.data;
                    switch (this.advert.interval) {
                        case 1:
                            this.interval = [1];
                            break;
                        case 2:
                            this.interval = [2];
                            break;
                        default :
                            this.interval = [1, 2];
                            break;
                    }
                }
            });
            adamApi.get(api.clients).
            then(response => {
                if (response.status === 200) {
                    this.clients = response.data
                }
            });
        }
    }
</script>
